define('MM/Models/ContentSearch/FacetSingleChoiceValue',["knockout", "score_bootstrap/Models/SitecoreId"], function (ko, SitecoreId) {
    "use strict";

    function FacetSingleChoiceValue(id, value, text, rowElement, koCheckedValue) {
        this.id = SitecoreId.parse(id);
        this.value = value;
        this.text = text;
        this.checked = koCheckedValue;
        this.selected = ko.pureComputed(function () { return this.checked() === this.value; }, this);
        this.count = ko.observable(0);
        this.disabled = ko.observable(false);

        this.resetCount = function () {
            this.count(0);
        };

        ko.applyBindings(this, rowElement);
    }

    return FacetSingleChoiceValue;
});
